module.exports = __webpack_public_path__ + "static/media/loupe.c4f15099.svg";